<template>
    <input-field :label="label" v-model="value" :rules="rules" :prepend-inner-icon="prependInnerIcon" />
</template>

<script>
    import InputField from "../components/InputField";
    import validations from "./validations";

    export default {
        name: "PINNumber",
        props: {
            label: {
                type: String
            },
            value: {
                type: String
            },
            rules: {
                default: function () {
                    return validations.checkPINNumber;
                }
            },
            "prepend-inner-icon": {
                default: 'fa-id-card'
            }
        },
        watch: {
            value() {
                this.$emit('input', this.value);
            }
        },
        components: {InputField}
    }
</script>

<style scoped>

</style>

